export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    title: that.$l('INDEX.table_label_operation') || '操作',
    field: 'col-opt',
    width: 85,
    align: 'center',
    slots: { default: 'opt' },
  },
  {
    type: 'expand',
    width: 75,
    align: 'center',
    title: that.$l('INDEX.form_label_expand') || '展开',
    slots: { content: 'expandContent' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.proofing_label_proofingType') || '打样类型',
    field: 'v_proofingType',
    align: 'center',
    width: 130,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.proofing_label_demandTime') || '需求时间',
    field: 'demandTime',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.proofing_label_qty') || '需求数量',
    field: 'qty',
    align: 'center',
    width: 80,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.proofing_label_sampleUse') || '样品用途',
    field: 'sampleUse',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.proofing_label_proofingRequirement') || '交付要求',
    field: 'proofingRequirement',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.proofing_label_photoRequirement') || '拍摄要求',
    field: 'photoRequirement',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    width: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
